import { Link } from "react-router-dom";
import { FaCompass, FaSuitcaseRolling, FaUserCheck } from "react-icons/fa";
import BackgroundSlideshow from "./BackgroundSlideshow";
import SpecialsStrip from "./SpecialsStrip";
import { useLocale } from "../i18n/LocaleContext";

// Paired with philosophy.pillars order in src/i18n/messages.ts
const PILLAR_ICONS: React.ReactNode[] = [
    <FaCompass key="compass" aria-hidden="true" />,
    <FaSuitcaseRolling key="suitcase" aria-hidden="true" />,
    <FaUserCheck key="usercheck" aria-hidden="true" />,
];

const Home = () => {
    const { t } = useLocale();

    return (
        <div className="home-page">
            <BackgroundSlideshow />

            <section className="home-hero">
                <p className="hero-kicker">{t.hero.kicker}</p>
                <h1>{t.hero.title}</h1>
                <p className="hero-sub">{t.hero.sub}</p>
                <div className="hero-actions">
                    <a href="#ofertas" className="btn-primary btn-hero">{t.hero.offers}</a>
                    <Link to="/contact" className="btn-ghost btn-hero">{t.hero.contact}</Link>
                </div>
            </section>

            <SpecialsStrip />

            <section className="home-section">
                <div className="home-section-inner">
                    <p className="kicker">{t.philosophy.kicker}</p>
                    <h2>{t.philosophy.title}</h2>
                    <p className="section-sub">{t.philosophy.sub}</p>
                    <div className="philosophy-grid">
                        {t.philosophy.pillars.map((pillar, i) => (
                            <div className="pillar" key={pillar.title}>
                                {PILLAR_ICONS.at(i % PILLAR_ICONS.length)}
                                <h3>{pillar.title}</h3>
                                <p>{pillar.body}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="home-cta">
                <p className="kicker">{t.cta.kicker}</p>
                <h2>{t.cta.title}</h2>
                <p>{t.cta.body}</p>
                <div className="hero-actions">
                    <Link to="/contact" className="btn-hero btn-cta">{t.cta.button}</Link>
                </div>
            </section>
        </div>
    );
};

export default Home;
